import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { fmtRelative } from "@/lib/format";
import { ShieldAlert } from "lucide-react";

export default function AdminAudit() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/audit-log").then((r) => setItems(r.data)); }, []);

  return (
    <>
      <PageHeader eyebrow="Compliance" title="Admin audit log" description="Every super-admin action recorded." testid="admin-audit-header" />
      <div className="px-4 sm:px-6 md:px-10 py-8">
        <div className="border border-border">
          <div className="grid grid-cols-12 gap-2 px-4 py-2 border-b border-border label-eyebrow text-[10px] bg-muted/40">
            <div className="col-span-3">Actor</div>
            <div className="col-span-3">Action</div>
            <div className="col-span-4">Target</div>
            <div className="col-span-2 text-right">When</div>
          </div>
          {items.length === 0 && (
            <div className="px-6 py-12 text-center text-sm text-muted-foreground">
              <ShieldAlert className="w-8 h-8 mx-auto mb-2 opacity-50" />
              No audit events yet. Admin actions (save plans, save gateway keys, save branding) will appear here.
            </div>
          )}
          {items.map((it) => (
            <div key={it.id} className="grid grid-cols-12 gap-2 px-4 py-3 border-b border-border items-center text-sm" data-testid={`audit-row-${it.id}`}>
              <div className="col-span-3 truncate">{it.actor_email}</div>
              <div className="col-span-3"><span className="chip chip-pending">{it.action}</span></div>
              <div className="col-span-4 truncate font-mono text-xs">{it.target}</div>
              <div className="col-span-2 text-right text-xs text-muted-foreground">{fmtRelative(it.created_at)}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
